import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type ResetPasswordInput = {
	email: string;
};

export type ResetPasswordUseCase = UseCase<ResetPasswordInput, void>;

export function resetPasswordBuilder(authRepository: AuthRepository): ResetPasswordUseCase {
	return async function resetPassword(input: ResetPasswordInput): Promise<void> {
		const email = stringValueObject().validate('email', input.email);
		return authRepository.resetPassword(email);
	};
}
